module.exports = __webpack_public_path__ + "static/media/equipment02.d0b0fde0.jpg";